import {
  FETCH_PROMOS,
  FETCH_PROMOS_SUCCESS,
  FETCH_PROMOS_FAILED,
  EDIT_PROMOS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove } from "firebase/database";
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";

export const fetchPromos = () => (dispatch) => {

  const {
    promoRef
  } = firebase;

  dispatch({
    type: FETCH_PROMOS,
    payload: null
  });
  onValue(promoRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_PROMOS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_PROMOS_FAILED,
        payload: "No promos available."
      });
    }
  });
};

const uploadPromoImage = async (promoId, imageFile) => {
  const { promoImageRef } = firebase;
  await uploadBytesResumable(promoImageRef(promoId), imageFile);
  return getDownloadURL(promoImageRef(promoId));
};

export const editPromo = (promo, method, imageFile = null) => async (dispatch) => {
  const {
    promoRef,
    promoEditRef
  } = firebase;
  dispatch({
    type: EDIT_PROMOS,
    payload: { method, promo }
  });
  if (method === 'Add') {
    const newRef = push(promoRef);
    const promoId = newRef.key;
    const data = { ...promo, id: promoId };
    if (imageFile) {
      data.promo_image = await uploadPromoImage(promoId, imageFile);
    }
    await set(newRef, data);
  } else if (method === 'Delete') {
    await remove(promoEditRef(promo.id));
  } else if (method === 'UpdateImage') {
    const data = { ...promo };
    if (imageFile) {
      data.promo_image = await uploadPromoImage(promo.id, imageFile);
    }
    await set(promoEditRef(promo.id), data);
  } else {
    const data = { ...promo };
    if (imageFile) {
      data.promo_image = await uploadPromoImage(promo.id, imageFile);
    }
    await set(promoEditRef(promo.id), data);
  }
}
